(function(angular){
	'use strict';
	
	angular.module('metroMarketMapModule', [
		'BaseConfig', 
		'reitServiceModule', 
		'SharedFilters'
	]);

})(window.angular);